import styled from 'styled-components';

const RecipesTemplateStyle = styled.section`
	--recipesLargeDistance: var(--sp13x);
	--recipesItemGap: var(--sp6x);
	--recipesItemDistance: var(--sp9x);

	margin-top: var(--recipesLargeDistance);

	.call-to-action-wrapper {
		/* margin-top: var(--recipesLargeDistance); */
		margin-top: var(--sectionDistance);
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--recipesLargeDistance: var(--sp10x);
		--recipesItemGap: var(--sp4x);
		--recipesItemDistance: var(--sp8x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--recipesLargeDistance: var(--sp9x);
		--recipesItemGap: var(--sp3x);
		--recipesItemDistance: var(--sp7x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--recipesLargeDistance: var(--sp7x);
		--recipesItemGap: var(--sp2-5x);
		--recipesItemDistance: var(--sp6x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--recipesLargeDistance: var(--sp6x);
		--recipesItemGap: var(--sp2-5x);
		--recipesItemDistance: var(--sp5x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--recipesLargeDistance: var(--sp5x);
		--recipesItemGap: var(--sp2x);
		--recipesItemDistance: var(--sp5x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--recipesLargeDistance: var(--sp5x);
		--recipesItemGap: var(--sp2x);
		--recipesItemDistance: var(--sp4x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--recipesLargeDistance: var(--sp7x);
		--recipesItemGap: var(--sp1x);
		--recipesItemDistance: var(--sp4x);
	}
`;

export default RecipesTemplateStyle;
